var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = _this.visible;
        return _this;
    }
    Modal.prototype.watchVisible = function (val) {
        this.showModal = val;
        if (!val) {
            this.$emit('update:loading', false);
        }
    };
    Modal.prototype.beforeClose = function () {
        this.showModal = false;
        this.$emit('beforeClose');
    };
    Modal.prototype.submit = function () {
        this.$emit('confirm');
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Modal.prototype, "visible", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Modal.prototype, "loading", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], Modal.prototype, "hasFooter", void 0);
    __decorate([
        Prop({ type: String, default: '取消' })
    ], Modal.prototype, "cancelText", void 0);
    __decorate([
        Prop({ type: String, default: '确定' })
    ], Modal.prototype, "confirmText", void 0);
    __decorate([
        Prop({ type: String, default: '41.6vw' })
    ], Modal.prototype, "width", void 0);
    __decorate([
        Watch('visible')
    ], Modal.prototype, "watchVisible", null);
    Modal = __decorate([
        Component({})
    ], Modal);
    return Modal;
}(Vue));
export default Modal;
